import { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import Chart from 'react-apexcharts';

import { sentenceCase } from 'change-case';
import get from 'lodash.get';
import defaultsDeep from 'lodash.defaultsdeep';

import defaultOptions from './default_270_radial_options';

const PilingSummaryRadialChart = ({ pageData, TableBuildStatuses }) => {
  const chartData = useMemo(() => {
    if (pageData?.tableSummaryReport) {
      const tableData = get(pageData, 'tableSummaryReport.report.data.rows');
      const pilingCompleteRow = tableData.find(
        (d) => d.status === TableBuildStatuses.PILING_WORKS_COMPLETE
      );
      const contractorCompleteRow = tableData.find(
        (d) => d.status === TableBuildStatuses.CONTRACTOR_PILING_CHECKLIST_COMPLETE
      );
      const inspectorCompleteRow = tableData.find(
        (d) => d.status === TableBuildStatuses.INSPECTOR_PILING_CHECKLIST_COMPLETE
      );
      const newChartData = {
        pilingComplete: pilingCompleteRow.accumPercent,
        checklistComplete: contractorCompleteRow.accumPercent,
        inspectorAccepted: inspectorCompleteRow.accumPercent,
      };
      return newChartData;
    }
    return {};
  }, [pageData, TableBuildStatuses]);

  const series = Object.values(chartData);
  const options = defaultsDeep(
    {
      labels: Object.keys(chartData).map((k) => sentenceCase(k)),
      title: { text: 'Piling Summary' },
      colors: ['#3B82EC', '#3B82EC', '#4BBF73'],
    },
    defaultOptions
  );

  return (
    <Card>
      <Card.Body>
        <Chart options={options} series={series} type="radialBar" height="350" />
      </Card.Body>
    </Card>
  );
};

export default PilingSummaryRadialChart;
